import { toast } from 'react-toastify';
import axios from 'axios';
import { WISHLIST_ADD_ITEM, WISHLIST_REMOVE_ITEM, WISHLIST_SET_ITEMS, CLEAR_WISHLIST } from './wishlistActionTypes';

export function wishlistAddItemSuccess(product) {
    toast.success(`Product "${product.name}" added to wish list!`, { theme: 'colored' });

    return {
        type: WISHLIST_ADD_ITEM,
        product,
    };
}

export function wishlistRemoveItemSuccess(productId) {
    return {
        type: WISHLIST_REMOVE_ITEM,
        productId,
    };
}

export const setWishlistItems = (wishlist) => ({
    type: WISHLIST_SET_ITEMS,
    payload: wishlist,
});


export const fetchUserWishlist = (userId) => async (dispatch, getState) => {
    try {
        const state = getState();
        const token = state?.user.userConnected.accessToken;
        const response = await axios.get(`http://localhost:8080/api/v1/wishlist/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch(setWishlistItems(response.data.products));
    } catch (error) {
        console.error("Error fetching wishlist:", error);
    }
};

export const clearWislist = () => ({
    type: CLEAR_WISHLIST,
});


export function wishlistAddItem(product) {
    const productId = product.id;
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const token = state?.user.userConnected.accessToken;
            const userId = state?.user?.userConnected?.user?.id;

            const response = await axios.post(
                "http://localhost:8080/api/v1/wishlist/add",
                { userId, productId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 201) {
                dispatch(wishlistAddItemSuccess(product));
            }
        } catch (error) {
            console.error("Error adding item to wishlist:", error);
            toast.error("Failed to add item to wishlist", { theme: "colored" });
        }
    };
}


export function wishlistRemoveItem(itemId) {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const token = state?.user.userConnected.accessToken;
            const userId = state?.user?.userConnected?.user?.id;

            const response = await axios.post(
                "http://localhost:8080/api/v1/wishlist/remove",
                { userId, productId: itemId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                dispatch(wishlistRemoveItemSuccess(itemId));
            }
        } catch (error) {
            console.error("Error remove item to wishlist:", error);
            toast.error("Failed to remove item to wishlist", { theme: "colored" });
        }
    };
}
